<template>
    <dashboard-layout></dashboard-layout>
</template>

<script>
    import DashboardLayout from '@/layout/DashboardLayout.vue'

    export default {
        name: "Home",
        components: {
            DashboardLayout
        },
        data() {
            return {
            secretMessage: '',
            username: ''
            };
        },
        async created() {
            if (!this.$store.getters.isLoggedIn) {
                this.$router.push('/login');
            }
            this.username = this.$store.getters.getUser.username;
        }
    };
</script>